import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const CategoryView = () => {
  const [CategoryUser, setCategoryUser] = useState({
    category_id: "",
    category_name: "",
    image: "",
    created_at: "",
    updated_at: ""
  });

  const { id } = useParams();

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_main_category_by_id",
          { category_id: id }
        );

        if (response.data.success === "1") {
          setCategoryUser(response.data.row);
        } else {
          console.error("Failed to load category");
        }
      } catch (error) {
        console.error("There was an error!", error);
      }
    };

    fetchCategory();
  }, [id]);

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Categories View</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript:void(0);">Categories</Link>
                </li>
                <li className="breadcrumb-item active">Categories View</li>
              </ol>
            </div>
          </div>
        </div>

        {/* VIEW CARD */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card category-view">

              <div className="cross-icon">
                <Link to="/category-list">
                  <i className="fa-solid fa-circle-xmark"></i>
                </Link>
              </div>

              <div>
                <img
                  src={
                    CategoryUser.image
                      ? `https://cyberathon.com/multivendor/${CategoryUser.image}`
                      : "/images/no-image.png"
                  }
                  width={600}
                  height={400}
                  alt="Category Image"
                />
              </div>

              <strong>Category Name</strong>
              <p>{CategoryUser.category_name}</p>

              <strong>Created At</strong>
              <p>{CategoryUser.created_at}</p>

              <strong>Updated At</strong>
              <p>{CategoryUser.updated_at}</p>

            </div>
          </div>
        </div>

      </div>

      {/* Footer */}
            <footer className="footer">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 text-center">
                    © Venton. Crafted by{" "}
                    <iconify-icon
                      icon="iconamoon:heart-duotone"
                      className="fs-18 align-middle text-danger"
                    />{" "}
                    <Link to="#" className="fw-bold footer-text" target="_blank">
                      Techzaa
                    </Link>
                  </div>
                </div>
              </div>
            </footer>

    </div>
  );
};

export default CategoryView;
